//  valid positions: op-left top-right bottom-left bottom-right top bottom left right center

export const notifyConfiguration = {

    progress: true,
    position: 'top-right',
    // Affichage 20s par défaut pour toutes les notifications
    timeout: 20000,
    // Icône de fermeture systématique : un clic ferme la notification (Quasar dismisse au clic d'une action)
    actions: [
        {icon: 'fas fa-times', color: 'grey-6', round: true, flat: true, dense: true, attrs: {'aria-label': 'Fermer'}}
    ]
}
